export enum DateTypeEnum {
  EXACT = "EXACT",
  RANGE = "RANGE",
}
